"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intersectionalNames = exports.default = exports.SaleListingTypes = exports.SaleListingTypeNames = exports.SaleListingTypeKeys = exports.ResidentialListingTypes = exports.ResidentialListingTypeNames = exports.ResidentialListingTypeKeys = exports.RentListingTypes = exports.RentListingTypeNames = exports.RentListingTypeKeys = exports.OnMarketListingTypes = exports.ListingTypeNames = exports.ListingTypeName = exports.ListingTypeKeys = exports.ListingTypeByPageContext = exports.CommercialListingTypes = exports.CommercialListingTypeNames = exports.CommercialListingTypeKeys = exports.AllExceptBusinessListingTypes = exports.AllExceptBusinessListingTypeKeys = void 0;
var _listingCategory = _interopRequireDefault(require("./listing-category"));
var _listingLabel = _interopRequireDefault(require("./listing-label"));
var _filterObject = _interopRequireDefault(require("../utils/filter-object"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ListingTypeName;
(function (ListingTypeName) {
  ListingTypeName["RENTAL_RESIDENTIAL"] = "RENTAL_RESIDENTIAL";
  ListingTypeName["SALES_RESIDENTIAL"] = "SALES_RESIDENTIAL";
  ListingTypeName["RENTAL_COMMERCIAL"] = "RENTAL_COMMERCIAL";
  ListingTypeName["SALES_COMMERCIAL"] = "SALES_COMMERCIAL";
  ListingTypeName["SALES_BUSINESS"] = "SALES_BUSINESS";
  ListingTypeName["SHARE_RESIDENTIAL"] = "SHARE_RESIDENTIAL";
  ListingTypeName["DEVELOPMENTS_RESIDENTIAL"] = "DEVELOPMENTS_RESIDENTIAL";
  ListingTypeName["OFF_MARKET"] = "OFF_MARKET";
  ListingTypeName["SALES_EARLY_ACCESS"] = "SALES_EARLY_ACCESS";
})(ListingTypeName || (exports.ListingTypeName = ListingTypeName = {}));
var ListingTypeValues = {
  RENTAL_RESIDENTIAL: {
    name: ListingTypeName.RENTAL_RESIDENTIAL,
    label: 'Residential Rental Listings',
    isCommercial: false,
    titleFlavour: 'For Rent',
    category: _listingCategory.default.RENT,
    siteContext: 'RENT_RESIDENTIAL',
    pageContext: 'rent-residential',
    shortLabel: _listingLabel.default.RENTAL,
    pastParticiple: 'rented',
    urlContext: 'rent'
  },
  SALES_RESIDENTIAL: {
    name: ListingTypeName.SALES_RESIDENTIAL,
    label: 'Residential Sale Listings',
    labelPast: 'Residential Sold Listings',
    isCommercial: false,
    titleFlavour: 'For Sale',
    category: _listingCategory.default.BUY,
    siteContext: 'BUY_RESIDENTIAL',
    pageContext: 'sale-residential',
    shortLabel: _listingLabel.default.SALES,
    pastParticiple: 'sold',
    urlContext: 'sale'
  },
  RENTAL_COMMERCIAL: {
    name: ListingTypeName.RENTAL_COMMERCIAL,
    label: 'Commercial Rental Listings',
    isCommercial: true,
    titleFlavour: 'For Lease',
    category: _listingCategory.default.RENT,
    siteContext: 'RENT_COMMERCIAL',
    pageContext: 'rent-commercial',
    shortLabel: _listingLabel.default.RENTAL,
    pastParticiple: 'rented',
    urlContext: 'commercial-lease'
  },
  SALES_COMMERCIAL: {
    name: ListingTypeName.SALES_COMMERCIAL,
    label: 'Commercial Sale Listings',
    labelPast: 'Commercial Sold Listings',
    isCommercial: true,
    titleFlavour: 'For Sale',
    category: _listingCategory.default.BUY,
    siteContext: 'BUY_COMMERCIAL',
    pageContext: 'sale-commercial',
    shortLabel: _listingLabel.default.SALES,
    pastParticiple: 'sold',
    urlContext: 'commercial-sale'
  },
  SALES_BUSINESS: {
    name: ListingTypeName.SALES_BUSINESS,
    label: 'Business Sales',
    labelPast: 'Business Sold',
    isCommercial: true,
    titleFlavour: 'For Sale',
    category: _listingCategory.default.BUY,
    siteContext: 'BUY_BUSINESS',
    pageContext: 'sale-business',
    shortLabel: _listingLabel.default.SALES,
    pastParticiple: 'sold',
    urlContext: 'commercial-business'
  },
  SHARE_RESIDENTIAL: {
    name: ListingTypeName.SHARE_RESIDENTIAL,
    label: 'Residential Share Listings',
    isCommercial: false,
    titleFlavour: 'To Share',
    category: _listingCategory.default.SHARE,
    siteContext: 'SHARE_RESIDENTIAL',
    pageContext: 'share-residential',
    shortLabel: _listingLabel.default.SHARE,
    pastParticiple: 'rented',
    urlContext: 'share'
  },
  DEVELOPMENTS_RESIDENTIAL: {
    name: ListingTypeName.DEVELOPMENTS_RESIDENTIAL,
    label: 'New Homes',
    labelPast: 'New Homes Sold',
    isCommercial: false,
    titleFlavour: 'For Sale',
    category: _listingCategory.default.DEVELOPMENTS,
    siteContext: 'DEVELOPMENTS_RESIDENTIAL',
    pageContext: 'developments-residential',
    pageContextOther: 'new-homes-residential',
    shortLabel: _listingLabel.default.SALES,
    pastParticiple: 'sold',
    urlContext: 'new-homes'
  },
  OFF_MARKET: {
    name: ListingTypeName.OFF_MARKET
  },
  SALES_EARLY_ACCESS: {
    name: ListingTypeName.SALES_EARLY_ACCESS,
    label: 'Early Access Sale Listings',
    isCommercial: false,
    titleFlavour: 'For Sale',
    category: _listingCategory.default.BUY,
    siteContext: 'BUY_RESIDENTIAL',
    pageContext: 'sale-early-access',
    shortLabel: _listingLabel.default.SALES,
    pastParticiple: 'sold',
    urlContext: 'sale'
  }
};
var ListingType = ListingTypeValues;
var CommercialListingTypes = exports.CommercialListingTypes = (0, _filterObject.default)(ListingType, each => each.isCommercial);
var ResidentialListingTypes = exports.ResidentialListingTypes = (0, _filterObject.default)(ListingType, each => !each.isCommercial);
var SaleListingTypes = exports.SaleListingTypes = (0, _filterObject.default)(ListingType, each => each.category === _listingCategory.default.BUY);
var RentListingTypes = exports.RentListingTypes = (0, _filterObject.default)(ListingType, each => each.category === _listingCategory.default.RENT);
var OnMarketListingTypes = exports.OnMarketListingTypes = (0, _filterObject.default)(ListingType, each => each.name !== 'OFF_MARKET' && each.name !== 'SALES_EARLY_ACCESS');
var AllExceptBusinessListingTypes = exports.AllExceptBusinessListingTypes = (0, _filterObject.default)(OnMarketListingTypes, each => each.name !== 'SALES_BUSINESS');
var SaleListingTypeNames = exports.SaleListingTypeNames = Object.keys(SaleListingTypes);
var RentListingTypeNames = exports.RentListingTypeNames = Object.keys(RentListingTypes);
var ResidentialListingTypeNames = exports.ResidentialListingTypeNames = Object.keys(ResidentialListingTypes);
var CommercialListingTypeNames = exports.CommercialListingTypeNames = Object.keys(CommercialListingTypes);
var ListingTypeNames = exports.ListingTypeNames = Object.keys(ListingType);
var SaleListingTypeKeys = exports.SaleListingTypeKeys = Object.keys(SaleListingTypes);
var RentListingTypeKeys = exports.RentListingTypeKeys = Object.keys(RentListingTypes);
var ResidentialListingTypeKeys = exports.ResidentialListingTypeKeys = Object.keys(ResidentialListingTypes);
var CommercialListingTypeKeys = exports.CommercialListingTypeKeys = Object.keys(CommercialListingTypes);
var AllExceptBusinessListingTypeKeys = exports.AllExceptBusinessListingTypeKeys = Object.keys(AllExceptBusinessListingTypes);
var ListingTypeKeys = exports.ListingTypeKeys = Object.keys(ListingType);
var intersectionalNames = exports.intersectionalNames = function intersectionalNames() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }
  return types.length === 0 ? [] : types.reduce((resultSet, type) => resultSet.filter(each => type[each]), Object.keys(ListingType));
};
var ListingTypeByPageContext = exports.ListingTypeByPageContext = Object.keys(ListingType).reduce((map, listingTypeKey) => {
  var listingType = ListingType[listingTypeKey];
  if (listingType.pageContext) {
    map[listingType.pageContext] = listingType.name;
  }
  return map;
}, {});
var _default = exports.default = ListingType;